import { getCustomerInfo } from '@/utils/customers';

export default class {
	constructor(options, props) {
		if (Object.keys(options || {}).length === 0 || !options.path) {
			throw 'The path in options is required';
		}

		this.prefix = options.prefix || '';
		this.basePath = options.path;
		this.keys = Object.keys(props || {});

		if (this.keys.length === 0) {
			//default values
			this.defaults = {
				recordStart: 1,
				maxCount: 100,
				orderBy: 'name',
				orderDirection: 'desc',
				search: ''
			};

			this.keys = Object.keys(this.defaults);
		} else {
			this.defaults = props;
		}
	}

	path = (base = null) => {
		base = base || this.basePath;

		return base + this.getPropPath();
	};

	parsePath = (base = null) => {
		base = base || this.basePath;

		return base + this.getPropValuePath();
	};

	parseParams(params) {
		if (params) {
			const isNumeric = str => {
				if (typeof str != 'string') return false;
				return !isNaN(str) && !isNaN(parseFloat(str));
			};

			let objResult = {};
			if (params['id']) {
				objResult.id = isNumeric(params.id)
					? parseInt(params.id)
					: params.id;
			}
			if (params['name']) {
				objResult.name = params.name;
			}

			if (params['customerId']) {
				objResult.customerParam = this.parseCustomerParams(
					params.customerId
				);
			}

			this.keys.forEach(k => {
				const val = params[k] || '';
				objResult[k] = isNumeric(val) ? parseInt(val) : val; // encodeURIComponent(val);
			});
			return objResult;
		}

		return {};
	}

	routeRedirect = (base = null) => {
		base = base || this.basePath;
		const parseTo = (path, to) => {
			if (base.indexOf('/:') == -1) {
				return path;
			}
			const params = path.split('/')?.filter(x => x.startsWith(':'));

			params.forEach(p => {
				path = path.replace(
					p,
					to.params[p.replace(/[^a-zA-Z]/g, '')] //encodeURIComponent(to.params[p.replace(/[^a-zA-Z]/g, '')])
				);
			});

			return path;
		};

		const route = {
			path: base,
			redirect: to => {
				return this.parsePath(parseTo(base, to));
			}
		};

		return route;
	};

	parseCustomerParams = customerId => {
		return getCustomerInfo(customerId, this.prefix);
	};

	//utils functions
	getPropPath() {
		const propPath = this.keys
			.map(key => {
				return `(${key}-):${key}?`;
			})
			.join('/');

		return `/${propPath}`;
	}

	getPropValuePath() {
		const propPath = this.keys
			.map(
				key =>
					key +
					'-' +
					(this.defaults[key] === undefined ||
					this.defaults[key] === null ||
					this.defaults[key] == 0
						? ''
						: encodeURIComponent(this.defaults[key]))
			)
			.join('/');

		return `/${propPath}`;
	}
}
